import { createAsyncThunk } from '@reduxjs/toolkit'

import {
  cashoutService,
  getBetsHistoryService,
  getTowerCurrentGameStateService,
  openedTileService,
  placeBetService
} from '../towerGame.service'
import { BET_RESULT } from 'utils/constants/index'
import { openSuccessToaster } from 'helpers/toaster.helpers'
import i18n from 'i18next'

export const getBetsHistoryThunk = createAsyncThunk('tower/fetch-bets', async (data, thunkApi) => {
  try {
    const res = await getBetsHistoryService(data)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const placeBetThunk = createAsyncThunk('tower/place-bet', async (data, thunkApi) => {
  const { payload, onPlaceBetSuccess } = data
  try {
    const res = await placeBetService(payload)
    openSuccessToaster({
      message: i18n.t('BET_PLACED_SUCCESS')
    })
    onPlaceBetSuccess()
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const openedTileThunk = createAsyncThunk('tower/opened-tile', async (data, thunkApi) => {
  try {
    const res = await openedTileService(data)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const cashoutThunk = createAsyncThunk('tower/cashout', async (data, thunkApi) => {
  try {
    const { onSuccess } = data
    const res = await cashoutService()
    onSuccess({ cashoutResponse: res })
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const getCurrenctGameStateThunk = createAsyncThunk(
  'tower/get-current-game-state',
  async (_, thunkApi) => {
    try {
      const res = await getTowerCurrentGameStateService()
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)
